var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("\n    Test Page.\n    "),_c('br'),_vm._v("\n    "+_vm._s(_vm.showNavBar)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }